import React from "react";
import clsx from "clsx";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "grey"
  | "transparent"
  | "white"
  | "info"
  | "tertiary"
  | "default"
  | "default2"
  | "disabled"
  | "tertiary-s"
  | "select"
  | "emergency-status";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "small" | "medium" | "large";
  padding?: "default" | "goods";
  fullWidth?: boolean;
  validation?: boolean;
  testId?: string;
}

export default function CommonButton({
  children,
  testId,
  className,
  validation = false,
  variant = "primary",
  size = "medium",
  fullWidth = false,
  padding = "default",
  ...rest
}: Props) {
  return (
    <button
      className={clsx([
        "rounded flex justify-center items-center gap-1 disabled:opacity-60",
        size === "small"
          ? "text-sm"
          : size === "large"
          ? "text-lg"
          : "text-base leading-[19px] font-medium",
        fullWidth ? "w-full" : "inline-block",
        {
          "px-4 py-2": padding === "default",
          "py-[11px] px-2": padding === "goods",
          "bg-button-primary-default text-white active:bg-button-primary-hover":
            variant === "primary",
          "text-brand-primary-gray-100 bg-[#D6D9DA]": variant === "secondary",
          "bg-neutral-300": variant === "grey",
          "bg-white py-4 text-neutral-500": variant === "transparent",
          "bg-white text-black": variant === "white",
          " bg-brand-neutral-05 border-brand-gray-20 border-opacity-20 border text-black text-opacity-40":
            variant === "info",
          "bg-white border border-brand-primary-gray-20 border-opacity-20 rounded-[3px] px-4 py-3":
            variant === "tertiary",
          " text-brand-neutral-80 bg-brand-gray-10 bg-opacity-10":
            variant === "default",
          "bg-brand-neutral-05 text-black font-medium text-opacity-40 border border-brand-gray-100 border-opacity-20 text-[13px] leading-[17px] rounded-[3px] h-[32px] px-2.5 py-[11px]":
            variant === "tertiary-s",
          "py-4 leading-[19px] !rounded-[20px] h-[40px] text-base border border-brand-neutral-30 font-brand-neutral-100":
            variant === "default2",
          "bg-brand-neutral-20 text-brand-primary-gray-100 !opacity-30 bg-none active:bg-brand-neutral-20 active:text-brand-primary-gray-100":
            variant === "disabled" || rest.disabled || validation,
          "bg-white border border-black rounded-none ": variant === "select",
          "bg-white rounded-[3px] py-[14px] px-4":
            variant === "emergency-status",
        },
        className,
      ])}
      data-testid={`${testId}-common-button`}
      {...rest}
    >
      {children}
    </button>
  );
}
